// ** UI
import Box from '@mui/material/Box';

type CloseIconProps = {
	size?: number;
};

const CloseIcon = ({ size = 24 }: CloseIconProps) => (
	<Box
		component="svg"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		strokeWidth="2"
		strokeLinecap="round"
		aria-hidden="true"
		sx={{ width: size, height: size, display: 'block' }}
	>
		<line x1="18" y1="6" x2="6" y2="18" />
		<line x1="6" y1="6" x2="18" y2="18" />
	</Box>
);

export default CloseIcon;
